import propTypes from 'prop-types';
import React, { useEffect } from 'react';

const Modal = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' || event.keyCode === 27) {
        onClose();
      }
    };

    if (isOpen) {
      // Add the event listener when the modal is open
      window.addEventListener('keydown', handleKeyDown);
    }

    // Remove the event listener when the component unmounts or the modal is closed
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-content">
          <button className="close-button" onClick={onClose}>
            &times;
          </button>
          {children}
        </div>
      </div>
      <style jsx>
        {`
          /* Modal.css */
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.2); /* semi-transparent background */
            display: flex;
            justify-content: center;
            align-items: center;
            backdrop-filter: blur(8px); /* blur the background */
            z-index: 1000;
          }

          .modal-content {
            background-color: white;
            padding: 20px;
            border-radius: 8px;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
            position: relative;
            width: 80%;
            max-width: 500px;
          }

          .close-button {
            position: absolute;
            top: 10px;
            right: 10px;
            background: none;
            border: none;
            font-size: 24px;
            cursor: pointer;
            color: #555;
          }
        `}
      </style>
    </>
  );
};
Modal.propTypes = {
  children: propTypes.node.isRequired,
  isOpen: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
};
export default Modal;
